import { types } from "../types/types";

const initialState = {
    logsProfesional: [],
    totalLogsProfesional: 0,
    pagination: null,
    loading: false,
    error: null
}

export const vacacionesLogsReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.vacacionesLogsProfesionalLoad:
            return {
                ...state,
                logsProfesional: action.payload.logs,
                totalLogsProfesional: action.payload.total,
                pagination: action.payload.pagination,
                loading: false,
                error: null
            }

        default:
            return state;
    }
}

